<template>
  <div>
    <section class="back-section">
      <div class="back-section__container">
        <h2>系統導覽，請選擇你要觀看的教學</h2>
        <ul class="guide-ctrl d-flex flex-wrap">
          <li id="navBitton11" @click="guideHandler(0)" v-show="checkinHandler">
            功能導覽
          </li>
        </ul>
        <div id="site-navigation-box" :class="{ open: open }"></div>
      </div>
    </section>
  </div>
</template>

<script>
let stepHandler = {
  sidbarGuide: [
    {
      src: `https://abc820219.github.io/code/#/back/dashboard`,
      target: '.adminGuide', //css selector
      navBoxPos: {
        x: 'right',
        y: 'bottom',
      },
      info: '點擊控制臺，觀看訂單銷量。',
      func: '',
    },
    {
      src: `https://abc820219.github.io/code/#/back/dashboard`,
      target: '.productGuide', //css selector
      navBoxPos: {
        x: 'right',
        y: 'bottom',
      },
      info: '點擊產品列表，新增改查產品。',
      func: '',
    },
    {
      src: `https://abc820219.github.io/code/#/back/dashboard`,
      target: '.couponGuide', //css selector
      navBoxPos: {
        x: 'right',
        y: 'bottom',
      },
      info: '點擊優惠卷列表，新增刪優惠卷。',
      func: '',
    },
    {
      src: `https://abc820219.github.io/code/#/back/dashboard`,
      target: '.orderGuide', //css selector
      navBoxPos: {
        x: 'right',
        y: 'bottom',
      },
      info: '點擊訂單列表，查看訂單狀況。',
      func: '',
    },
    {
      src: `https://abc820219.github.io/code/#/back/dashboard`,
      target: '.stoargeGuide', //css selector
      navBoxPos: {
        x: 'right',
        y: 'bottom',
      },
      info: '點擊控制臺功能，觀看訂單銷量。',
      func: '',
    },
  ],
};
import { mapState } from 'vuex';
export default {
  // 權限判斷
  created() {
    this.reservationHandler = this.menu[0].children.some(item => {
      return item.domId === 'reservation';
    });
  },
  // 額外處理已證實(alex也說這是目前最好的解法)
  mounted() {
    window.navigationStart = this.navigationStart;
    window.navigationCancel = this.navigationCancel;
  },
  computed: {
    ...mapState(['menu']),
  },
  data() {
    return {
      checkinHandler: true,
      infoBoxStyle: ` position: absolute;
            			    left: 0;
            			    top: 0;
            			    padding: 1em;
            			    width: 200px;
            			    background-color:#39352e;
            			    lightblue;
            			    opacity: 0;
            			    transform: translateY(20px);
            			    transition: opacity .45s ease-out, transform .6s ease-out;`,
      frameStyle: `position: relative;
            				  width: 100%;
            				  height: 100%;
            				  display: block;`,
      maskStyle: `position: fixed;
            				 left: 0;
            				 top: 0;
            				 width: 100%;
            				 height: 100%;
                             background-image: none;
            				 z-index: 99999;
                             transition: background-image .75s ease-out;
                             `,
      spanStyle: `position: absolute;
            				 width: 0;
            				 height: 0;
            				 background: rgba(50, 50, 50, .6);
            				 display: block;
                             transition: width .35s cubic-bezier(.25,.64,.63,1.13), height .35s cubic-bezier(.25,.64,.63,1.13);`,
      nextButtonStyle: `
                             background:transparent;
                             color:#fff;
            `,
      cancelButtonStyle: `
                             background:transparent;
                             color:#fff;
            `,
      stepHandler: {},
      navSetting: [
        {
          navButton: '#navBitton0', //css selector
          navBox: '#site-navigation-box', //css selector
          steps: stepHandler.sidbarGuide,
          stepInit: -1,
          endFunc: this.navigationEnd,
        },
      ],
      navInfo: {},
      open: false,
      currentSettingNumber: null,
    };
  },
  methods: {
    guideHandler(number) {
      this.currentSettingNumber = number;
      this.navigationStart(number);
    },
    navigationStart(currentSetting) {
      let vm = this;
      vm.open = true;
      this.navInfo = this.navSetting[currentSetting];
      let navInfo = this.navInfo;
      let navBox = document.querySelector(navInfo.navBox);
      let infoP = document.createElement('P');
      let nextButton = document.createElement('BUTTON');
      let cancelButton = document.createElement('BUTTON');
      // 自動停止
      navInfo.stepInit < navInfo.steps.length - 1
        ? (navInfo.stepInit += 1)
        : (navInfo.stepInit = -1);
      if (navInfo.stepInit == -1) {
        navInfo.endFunc();
        return false;
      }
      //----------------------------------------------
      let sameSrc =
        navInfo.stepInit >= 1 &&
        navInfo.steps[navInfo.stepInit].src ==
          navInfo.steps[navInfo.stepInit - 1].src
          ? true
          : false;

      sameSrc
        ? navBox.removeChild(navBox.childNodes[1])
        : (navBox.innerHTML = '');

      //----------------------------------------------
      let frame = sameSrc
        ? navBox.querySelector('iframe')
        : document.createElement('IFRAME');
      let infoBox = document.createElement('DIV');
      0;
      let scrollOut = sameSrc
        ? navBox.querySelector('iframe').contentWindow.document.documentElement
            .scrollTop
        : 0;
      // 文字內容
      frame.src = navInfo.steps[navInfo.stepInit].src;
      infoP.innerText = navInfo.steps[navInfo.stepInit].info;
      infoP.style.cssText = `line-height:1.5;color:#fff`;
      // 事件
      nextButton.setAttribute('onclick', `navigationStart(${currentSetting})`);
      cancelButton.setAttribute('onclick', `navigationCancel()`);
      //樣式區
      infoBox.setAttribute('class', 'navigation-information');
      frame.style.cssText = this.frameStyle;
      infoBox.style.cssText = this.infoBoxStyle;
      nextButton.style.cssText = this.nextButtonStyle;
      cancelButton.style.cssText = this.cancelButtonStyle;
      nextButton.innerText = 'Next';
      cancelButton.innerText = 'Cancel';

      if (!sameSrc) navBox.appendChild(frame);
      navBox.appendChild(infoBox);
      infoBox.appendChild(infoP);
      infoBox.appendChild(nextButton);
      infoBox.appendChild(cancelButton);
      // 不是張大的
      if (sameSrc) {
        vm.afterFrameLoads(navBox, infoBox, scrollOut, currentSetting);
      }
      navBox.querySelector('iframe').addEventListener('load', function() {
        // 0
        console.log(scrollOut);
        vm.afterFrameLoads(navBox, infoBox, scrollOut, currentSetting);
      });
    },
    afterFrameLoads(navBox, infoBox, scrollOut, currentSetting) {
      // console.log(2);
      // 0
      let vm = this;
      let navInfo = this.navInfo;
      let frameDoc = navBox.querySelector('iframe').contentWindow.document;

      console.log(frameDoc.querySelector('.searchBtnGuide'));
      console.log(frameDoc.querySelector('.formEditGuide'));
      console.log(navInfo.steps[navInfo.stepInit]['target']);
      let target = frameDoc.querySelector(
        navInfo.steps[navInfo.stepInit]['target'],
      );
      if (!target) {
        console.log('找不到dom');
        this.navigationStart(currentSetting);
        return;
      }
      let boxPosX = navInfo.steps[navInfo.stepInit].navBoxPos.x;
      let boxPosY = navInfo.steps[navInfo.stepInit].navBoxPos.y;
      let boxWidth = infoBox.getBoundingClientRect().width;
      let boxHeight = infoBox.getBoundingClientRect().height;
      let topLimit =
        target.getBoundingClientRect().top - 200 <= 0
          ? 0
          : target.getBoundingClientRect().top - 200;
      console.log(target.getBoundingClientRect().top);
      // 0
      frameDoc.documentElement.scrollTop = scrollOut;

      function scroll2Top() {
        let scrolling;
        if (frameDoc.documentElement.scrollTop < topLimit) {
          const scrollHeight =
            frameDoc.body.scrollHeight || frameDoc.documentElement.scrollHeight;
          const clientHeight =
            frameDoc.body.clientHeight || frameDoc.documentElement.scrollHeight;
          const scrollTop =
            frameDoc.body.scrollTop || frameDoc.documentElement.scrollTop;
          console.log(scrollTop);
          console.log(scrollHeight);
          console.log(clientHeight);
          if (scrollTop >= scrollHeight - clientHeight - 5) {
            console.log('頁面滑動到底部');
            clearTimeout(scrolling);
            showNavInfo(target, boxPosX, boxPosY);
          } else {
            frameDoc.documentElement.scrollTop += 10;
            scrolling = setTimeout(() => {
              scroll2Top();
            }, 10);
          }
        } else {
          clearTimeout(scrolling);
          showNavInfo(target, boxPosX, boxPosY);
        }
      }

      function showNavInfo(target, boxPosX, boxPosY) {
        if (frameDoc.querySelector('.temp-mask'))
          frameDoc.querySelector('.temp-mask').remove();
        var mask = frameDoc.createElement('DIV');
        mask.classList.add('temp-mask');
        mask.style.cssText = vm.maskStyle;

        frameDoc.body.appendChild(mask); //iframe 頁面遮罩，避免事件觸發
        frameDoc.body.style.overflow = 'hidden'; //先鎖住 iframe 頁面中的滾動事件，免得滾來滾去

        for (let i = 0; i < 4; i++) {
          let span = frameDoc.createElement('SPAN');
          span.style.cssText = vm.spanStyle;
          mask.appendChild(span);
        }

        //= = = = = 事 件 處 理 = = = = = = = = = = = = = =
        // hover傳遞進去原本目標 ifream物件 第三參數
        if (vm.navInfo.steps[vm.navInfo.stepInit].func) {
          let newTargetName =
            vm.navInfo.steps[vm.navInfo.stepInit].newTargetName;
          target = vm.navInfo.steps[vm.navInfo.stepInit].func(
            target,
            frameDoc,
            newTargetName,
          );
        }

        setTimeout(() => {
          // console.log(4 + '顯示');
          let x = target.getBoundingClientRect()[boxPosX],
            y = target.getBoundingClientRect()[boxPosY];
          // 漂浮版樣式
          target.style.outline = '#fff 2px dashed';
          target.style.outlineOffset = '5px';
          console.log(boxPosX);
          infoBox.style.left =
            boxPosX.toLowerCase() == 'left'
              ? x - boxWidth - 16 + 'px'
              : boxPosX.toLowerCase() == 'width'
              ? x / 2 + 'px'
              : x + 16 + 'px';
          infoBox.style.top =
            boxPosY.toLowerCase() == 'top'
              ? y - boxHeight - 16 + 'px'
              : y - 16 + 'px';
          infoBox.style.transform = 'translateY(0)';
          infoBox.style.opacity = 1;
          // 背景樣式
          mask.getElementsByTagName(
            'span',
          )[0].style.cssText += `left: 0; top: 0; width: 100%; height: ${target.getBoundingClientRect()
            .top - 10}px;`;

          mask.getElementsByTagName(
            'span',
          )[1].style.cssText += `left: 0; top: 0; width: ${target.getBoundingClientRect()
            .left - 10}px; height: 100%; transition-delay: .15s;`;

          mask.getElementsByTagName(
            'span',
          )[2].style.cssText += `right: 0; top: 0; width: calc(100% - ${target.getBoundingClientRect()
            .right + 10}px); height: 100%; transition-delay: .3s;`;

          mask.getElementsByTagName(
            'span',
          )[3].style.cssText += `left: 0; bottom: 0; width: 100%; height: calc(100% - ${target.getBoundingClientRect()
            .bottom + 10}px); transition-delay: .45s;`;
        }, 1000);
      }

      scroll2Top();
    },
    // 結束
    navigationEnd() {
      let vm = this;
      vm.open = false;
      this.$fire({
        title: '確定是否要再看一次?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '是',
        cancelButtonText: '否',
      }).then(result => {
        if (result.value === true) {
          document.querySelector(this.navInfo.navBox).innerHTML = '';
          this.guideHandler(this.currentSettingNumber);
          return;
        }
        document.querySelector(this.navInfo.navBox).innerHTML = '';
        this.navInfo = {};
      });
    },
    // 取消
    navigationCancel() {
      let vm = this;
      vm.open = false;
      // 重新設定防止samsrc出錯
      (this.navSetting = [
        {
          navButton: '#navBitton0', //css selector
          navBox: '#site-navigation-box', //css selector
          steps: stepHandler.sidbarGuide,
          stepInit: -1,
          endFunc: this.navigationEnd,
        },
      ]),
        (document.querySelector(this.navInfo.navBox).innerHTML = '');
      this.navInfo = {};
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #fff;
}
.guide-ctrl {
  li {
    padding: 5px;
    border: 1px dashed #000;
    flex: 1 1 680px;
    cursor: pointer;
    background: #fff;
    margin: 5px;
  }
  li:hover {
    color: #fff;
    background-color: rgba(0, 0, 0, 0);
  }
}
#site-navigation-box.open {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
}
.navigation {
  padding: 5vh 5vw;
}
.navigation h1 {
  font-size: 1.75em;
}
.navigation button {
  padding: 5px 10px;
  font-size: 1.25em;
  color: white;
  background: #227fac;
  border-radius: 5px;
  transition: all 0.25s;
}
.navigation button:hover {
  box-shadow: -3px -2px 5px rgba(200, 200, 200, 0.9);
}
</style>
